import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, ButtonBase, lighten, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import MonthTour from '../../../../models/MonthTour';
import Tour from '../../../../models/Tour';
import WhatsAppReserveButton from './WhatsAppReserveButton';

interface TourDateListItemProps {
    monthTour: MonthTour;
    tour: Tour
}

const TourDateListItem: React.FC<TourDateListItemProps> = ({ monthTour, tour }) => {
    const { t } = useTranslation();
    return (
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#e7e7e7ff" }} />}
                aria-controls="panel1-content"
                id="panel1-header"
            >
                <Typography variant='h6' fontWeight={600}>{monthTour.month}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {monthTour.tourWeeks.map((tourWeek) => (
                    <ButtonBase
                        key={`${monthTour.month}/${tourWeek.startDate}/${tourWeek.endDate}`}
                        sx={{
                            p: 1.5,
                            mb: 2,
                            width: "100%",
                            boxShadow: (theme) => theme.shadows[8],
                            bgcolor: (theme) => lighten(theme.palette.background.paper, 0.05),
                            justifyContent: "flex-start",
                            "&:hover": {
                                bgcolor: (theme) => lighten(theme.palette.background.paper, 0.2)
                            }
                        }}>
                        <Box
                            display={"flex"}
                            flexDirection={{ xs: "column", md: "row" }}
                            width={"100%"}
                            alignItems={{ xs: "start", md: "center" }}
                            gap={1}>
                            <Typography
                                fontWeight={600}
                                textAlign={"start"}
                                flexGrow={1}
                                color={"text2.primary"}>
                                📅 {tourWeek.startDate} – {tourWeek.endDate}
                            </Typography>

                            <WhatsAppReserveButton tourWeek={tourWeek} tour={tour} />
                        </Box>
                    </ButtonBase>
                ))}
            </AccordionDetails>
        </Accordion>

        // <Box>
        //     <Typography mt={2} variant='h6' fontWeight={600}>{monthTour.month}</Typography>
        //     <Box>
        //         {monthTour.tours.map((tour) => (
        //             <Paper sx={{ p: 1.5, mt: 1.5, boxShadow: (theme) => theme.shadows[6] }}>
        //                 <Box>
        //                     <Typography variant='subtitle2' fontWeight={600}>
        //                         {`${tour.checkInDate} - ${tour.checkOutDate}`}
        //                     </Typography>
        //                 </Box>
        //             </Paper>
        //         ))}
        //     </Box>
        // </Box>
    )
}

export default TourDateListItem;